import './app.scss';

import axios from 'axios';
import config from './app.json';

import { HubConnectionBuilder } from '@microsoft/signalr';
import { Context } from './Reducers/Store';
import React, { useEffect, useContext, useState } from 'react';
import Layout from './Pages/Layout';
import { LayoutEmpty } from './Pages/LayoutEmpty';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import RequireAuth from './RequireAuth';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
// Logged
import Home from './Pages/Logged/Home';
import { trackPageView } from './Utils/GoogleAnalytics';

// Not logged
import Login from './Pages/NotLogged/Login';
import Loading from './Components/Loading';

// import UpdateAndFaq from "./Pages/Logged/UpdateAndFaq";
import FaqAndUpdate from './Pages/Logged/FaqAndUpdate';
import Underconstruction from './Components/Underconstruction/underconstruction';
import SelectPlan from './Components/SelectPlan/selectplan';
import Configuration from './Components/Configuration/configuration';
import NewChatlist from './Components/NewChatlist/newchatlist';
import PaymentInfo from './Components/PaymentInfo/PaymentInfo';
import PaymentInfoMobile from './Components/PaymentInfoMobile/PaymentInfoMobile';
import SubscriptionCompleted from './Components/SubscriptionCompleted/subscriptioncompleted';
import HootSuiteCallback from './Components/HootSuiteCallback/hootsuitecallback';
import RecoverPassword from './Pages/NotLogged/RecoverPassword';
import NotFound from './Pages/NotFound';
import Terms from './Components/PrivacyAndTerms/terms';
import Privacy from './Components/PrivacyAndTerms/privacy';
import IndustryAndTeamMembers from './Components/IndustryAndTeamMembers/industryandteammembers';
import SelectPlanMobile from './Components/SelectPlanMobile/selectplanmobile';
import BackToMobile from './Components/BackToMobile/BackToMobile';
import Chat from './Components/ChatGpt/ChatGpt';

function App() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname); // Track every page visit
  }, [location]);

  const [state, dispatch] = useContext(Context);
  const [connection, setConnection] = useState(null);

  initializeApp(config.firebaseConfig);

  const handleErrorToLoadProfile = (error) => {
    // const waitTime = 1;

    // AlertComponent("Error", error.message ?? "Something went wrong. Please, login again.", { icon: `error` });

    // const timer = setTimeout(() => {
    localStorage.removeItem('auth');
    dispatch({ type: 'SET_LOGGED', payload: null });
    dispatch({ type: 'SET_HUB', payload: null });
    window.location.href = '/';
    // }, waitTime);

    // return () => clearTimeout(timer);
  };

  const refreshIdToken = async (refresh_token) => {
    const endpoint = `https://securetoken.googleapis.com/v1/token?key=${config.firebaseConfig.apiKey}`;
    try {
      const response = await axios.post(endpoint, {
        grant_type: 'refresh_token',
        refresh_token: refresh_token,
      });
      const data = response.data;
      dispatch({
        type: 'SET_LOGGED',
        payload: { token: data.access_token, refreshToken: data.refresh_token },
      });
    } catch (error) {
      handleErrorToLoadProfile({ message: 'Unable to update access token.' });
    }
  };

  useEffect(() => {
    try {
      var auth = localStorage.getItem('auth');
      if (auth != null)
        dispatch({ type: 'SET_LOGGED', payload: JSON.parse(auth) });
      else dispatch({ type: 'SET_READY', payload: true });
    } catch (error) {
      handleErrorToLoadProfile({
        message: 'Authentication could not be loaded.',
      });
    }
  }, [0]);

  useEffect(() => {
    if (state.isLogged) {
      dispatch({ type: 'SET_LOADING', payload: true });

      axios
        .get(config.API_HM + '/profile')
        .then((result) => {
          const payload = { ...result.data };

          dispatch([
            { type: 'SET_PROFILE', payload: payload },
            { type: 'SET_READY', payload: true },
          ]);
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            handleErrorToLoadProfile({
              message: 'Profile could not be loaded.',
            });
          } else {
            handleErrorToLoadProfile(error);
          }
        })
        .finally(() => {
          dispatch({ type: 'SET_LOADING', payload: false });
        });

      onAuthStateChanged(getAuth(), (user) => {
        if (user) {
          refreshIdToken(user.refreshToken);
        }
      });
    }
  }, [state.isLogged]);

  useEffect(() => {
    if (state.hubConnection) return;

    if (state.jwt && state.profile?.subscription) {
      if (connection && connection.state === 'Connected') connection.stop();

      const newConnection = new HubConnectionBuilder()
        .withUrl(config.API_HM + '/hubs/notifications', {
          accessTokenFactory: () => state.jwt,
          _accessTokenFactory: state.jwt,
          headers: {
            Authorization: 'Bearer ' + state.jwt,
          },
        })
        .withAutomaticReconnect()
        .build();

      setConnection(newConnection);
      dispatch([{ type: 'SET_HUB', payload: newConnection }]);
    }
  }, [state.jwt, state.profile?.subscription]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection
            .send('handshake', { protocol: 'json', version: 1 })
            .then(() => {})
            .catch((errorx) => {
              console.error('Erro ao estabelecer conexão:', errorx);
            });
        })
        .catch((e) => console.log('Connection failed: ', e));
    }
  }, [connection]);

  const handleShowConfig = () => {
    dispatch({ type: 'SET_CONFIG', payload: !state?.config ?? false });
  };

  const handleShowNewChatlist = () => {
    dispatch({
      type: 'SET_NEW_CHATLIST',
      payload: {
        newList: !state?.newlist ?? false,
        currentChatId: -1,
      },
    });
  };

  const handleAfterSaveChatlist = () => {
    dispatch({ type: 'SET_RELOAD_CHATLIST', payload: true });
  };

  const postSelectPlan = () => {
    window.location.reload();
  };

  const handleIndustryAndTeamSizeSave = () => {
    window.location.href = '/selectplan';
  };

  return state.ready ? (
    <div>
      {/* <BrowserRouter basename='/'> */}
      {state.profile?.subscription?.role && (
        <Configuration
          showConfig={state?.config ?? false}
          setShowConfig={handleShowConfig}
        />
      )}
      {state.profile?.subscription?.role && (
        <NewChatlist
          showCreateChat={state?.newlist ?? false}
          currentChatId={state?.currentChatId}
          setShowCreateChat={handleShowNewChatlist}
          afterCreateChat={handleAfterSaveChatlist}
        />
      )}

      <Routes>
        <Route path='/welcome' element={<Chat />} />
        <Route element={<LayoutEmpty />}>
          <Route
            path='/hscallback'
            element={
              <RequireAuth>
                <HootSuiteCallback />
              </RequireAuth>
            }
          />
          <Route path='/terms-of-service' element={<Terms />} />
          <Route path='/privacy-and-cookie-statement' element={<Privacy />} />
          <Route path='/login' element={<Login />} />
          <Route path='/sign-up' element={<Login />} />
          <Route path='/selectplanmobile' element={<SelectPlanMobile />} />
          <Route path='/paymentMobile' element={<PaymentInfoMobile />} />
          <Route path='/errormobile' element={<BackToMobile />} />
          <Route path='/successmobile' element={<BackToMobile />} />

          {!state.isLogged && (
            <>
              <Route path='/recoverpassword' element={<RecoverPassword />} />
            </>
          )}

          {state.isLogged && !state.profile?.subscription?.role && (
            <>
              <Route
                path='/selectplan'
                element={
                  <RequireAuth>
                    <SelectPlan
                      selectPlan={true}
                      postSelectPlan={postSelectPlan}
                    />
                  </RequireAuth>
                }
              />
              <Route
                path='/payment'
                element={
                  <RequireAuth>
                    <PaymentInfo />
                  </RequireAuth>
                }
              />
              <Route
                path='/subscriptionCompleted'
                element={
                  <RequireAuth>
                    <SubscriptionCompleted
                      selectPlan={true}
                      postSelectPlan={postSelectPlan}
                    />
                  </RequireAuth>
                }
              />
              <Route
                path='/industryandteammembers'
                element={
                  <RequireAuth>
                    <IndustryAndTeamMembers
                      containerClassName='out text-centered'
                      title='Tell us about yourself'
                      showSigningUpMessage={true}
                      firstScreen={true}
                      onSave={handleIndustryAndTeamSizeSave}
                    />
                  </RequireAuth>
                }
              />
            </>
          )}
        </Route>

        <Route element={<Layout />}>
          <Route
              path="/"
              element={
                <RequireAuth>
                  <Home connection={connection} />
                </RequireAuth>
              }
            />

          <Route
            path='/faq'
            element={
              <RequireAuth>
                <FaqAndUpdate />
              </RequireAuth>
            }
          />
          <Route
            path='/search'
            element={
              <RequireAuth>
                <Underconstruction />
              </RequireAuth>
            }
          />

          {/* Owner Only */}
          {state.isLogged && state.profile?.subscription?.role && (
            <>
              <Route
                path='/selectplan'
                element={
                  <RequireAuth roles={['Owner']}>
                    <SelectPlan />
                  </RequireAuth>
                }
              />
              <Route
                path='/subscriptionCompleted'
                element={
                  <RequireAuth roles={['Owner']}>
                    <SubscriptionCompleted />
                  </RequireAuth>
                }
              />
              <Route
                path='/payment'
                element={
                  <RequireAuth roles={['Owner']}>
                    <PaymentInfo />
                  </RequireAuth>
                }
              />
            </>
          )}
        </Route>

        <Route element={<LayoutEmpty />}>
          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
      {/* </BrowserRouter> */}
    </div>
  ) : (
    <Loading fakeLoad={true} />
  );
}

export default App;
